import styled from "styled-components";
import { DurationSelectorPresets } from "@similarweb/ui-components";
import { DurationSelectorSimple } from "app/components/duration-selector/DurationSelectorSimple";
import {
    MoreDataBanner,
    MoreDataBannerContainer,
    TextSection,
} from "pro-features/components/duration-selectors/DurationSelectedPresetOriented/steps/MoreDataBanner";
import { colorsPalettes } from "@similarweb/styles";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { translate } from "app/filters/i18nFilter";
import { useCallback } from "react";

const Wrapper = styled.div`
    height: auto;
    overflow-y: auto;
`;

const BottomSection = styled.div`
    padding: 3px;
    width: 200px;
    box-sizing: border-box;
    border-top: 1px solid ${colorsPalettes.carbon[50]};
    ${MoreDataBannerContainer} {
        height: 100%;
        ${TextSection} {
            margin-left: 0;
        }
    }
    button {
        margin-left: unset;
    }
`;

export const FixedDurationSelectorInner: React.FC<any> = ({
    closePopup,
    onPresetChange,
    items,
    selectedPreset,
    fixedRowHeight = 52,
    fullWidth = false,
    durationHookV4 = false,
}) => {
    const historicalDataText = translate("historical.data");
    const isHistoricalDataLocked = items?.find((item) => item.displayText === historicalDataText);
    const displayDurationHookV4Banner = durationHookV4 && isHistoricalDataLocked;

    const privateOnPresetChange = (item) => {
        if (typeof closePopup === "function") {
            closePopup();
        }
        onPresetChange(true)(item);
    };

    const handlePopupClose = useCallback(() => {
        closePopup?.();
    }, [closePopup]);

    const getItems = (items) => {
        if (displayDurationHookV4Banner) {
            return items.filter((item) => item.displayText !== historicalDataText);
        }
        return items;
    };

    const finalItems = getItems(items);

    return (
        <Wrapper>
            <DurationSelectorPresets
                itemsCount={finalItems.length}
                fixedRowHeight={fixedRowHeight}
                items={finalItems}
                selectedId={selectedPreset}
                onSelect={privateOnPresetChange}
                fullWidth={fullWidth}
            />
            {displayDurationHookV4Banner ? (
                <BottomSection>
                    <MoreDataBanner onClick={handlePopupClose} />
                </BottomSection>
            ) : null}
        </Wrapper>
    );
};

export class FixedDurationsSelector extends DurationSelectorSimple<{
    fullWidthPresetItems?: boolean;
}> {
    // override the default method of the base class, Since in this use case,
    // We need to allow custom duration to be the selected preset
    getSelectedPreset = (props) => {
        const selectedPreset = props.initialPreset;
        return selectedPreset;
    };
    getDurationSelectorStateless = () => {
        const items = this.props.presets;
        const { durationHookV4 } = proNavigator.current();
        return (
            <FixedDurationSelectorInner
                items={items}
                onPresetChange={this.onPresetSelect}
                selectedPreset={this.state.selectedPreset}
                fullWidth={this.props.fullWidthPresetItems}
                durationHookV4={durationHookV4}
            />
        );
    };
}
